export default __webpack_public_path__ + "static/media/taras.69aa52f2.jpg";